import { getСartTotal, renderCart } from './cart.js';

const cardsButtons = document.querySelectorAll('.catalog-card__button');
const spoilers = document.querySelectorAll('.catalog-card__spoiler');

const updateCatalogCardStatus = (cartItems) => {
  cardsButtons.forEach((button) => {
    const isInCart = cartItems.some(item => item.id === button.dataset.itemId);
    button.disabled = isInCart;
    button.textContent = isInCart ? 'В корзине' : 'Заказать';
  });
};

const saveCatalogCard = (cartItems) => {
  cardsButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const newItem = {
        id: button.dataset.itemId,
        title: button.dataset.itemTitle,
        price: button.dataset.itemPrice,
      };

      cartItems.push(newItem);
      localStorage.setItem('serviceCatalogCart', JSON.stringify(cartItems));

      updateCatalogCardStatus(cartItems);
      getСartTotal(cartItems);
      renderCart(cartItems);

      console.log(cartItems);
    });
  });
};

const initSpoilers = () => {
  spoilers.forEach((spoiler) => {
    const desc = spoiler.querySelector('.catalog-card__desc');
    const button = spoiler.querySelector('.catalog-card__readmore');

    button.addEventListener('click', () => {
      desc.classList.toggle('catalog-card__desc--opened');
    });
  });
};

initSpoilers();

export { 
  updateCatalogCardStatus, 
  saveCatalogCard, 
};